import React from "react";
import { Link, Typography } from "@mui/material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useDispatch, useSelector } from "react-redux";
import { removeEndorsement, removeSelectedCourse, removeDirectCourse } from "../../redux/actions/WizardLaunchActions";
import { clearCoupon } from "../../redux/actions/CartActions";
import './ShoppingCartStyle.scss';

function ProductList({ hasInstructorLed, endorsements, courses, directCourses }) {
  const dispatch = useDispatch();
  const { coupon } = useSelector(state => state.cart);

  // Filter out Instructor-Led courses, only show Self-Paced
  const selfPacedCourses = courses?.filter(course => course.courseType === "Self-Paced") || [];
  
  return (
    <div className="selected-sec">
      <Typography level="h2" className="heading-med">
        Selected
      </Typography>

      {/* Display Endorsements */}
      {endorsements?.length > 0 && (
        <div className="endorsements-section">
          {endorsements.slice() 
          .sort((a, b) => a.name.localeCompare(b.name)).map((product, index) => (
            <div className="product-grid" key={`endorsement-${index}`}>
              <div className="left-product-grid">
                <img src={product.imgUrl} alt="img" className="prod-img" />
                <Typography className="prod-title">{product.name}</Typography>
                {product.alreadyPurchased && <div>
                  <span className="existing_course">Already Purchased</span>
                </div>}
              </div>
              <div className="right-product-grid">
                <Typography className="price-lbl">${product.price}</Typography>
                <Link
                  className="remove-lbl"
                  onClick={() => {
                    if (coupon) {
                      dispatch(clearCoupon());
                    }
                    dispatch(removeEndorsement(endorsements.indexOf(product)));
                  }}
                >
                  <DeleteOutlinedIcon />
                  Remove
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Display Direct Courses */}
      {directCourses?.length > 0 && (
        <div className="direct-courses-section">
          {directCourses.slice() 
          .sort((a, b) => a.name.localeCompare(b.name)).map((course, index) => (
            <div className="product-grid" key={`direct-course-${index}`}>
              <div className="left-product-grid">
                <img src={course.imgUrl} alt="img" className="prod-img" />
                <Typography className="prod-title">{course.name}</Typography>
                {course.alreadyPurchased && <div>
                  <span className="existing_course">Already Purchased</span>
                </div>}
              </div>
              <div className="right-product-grid">
                <Typography className="price-lbl">${course.price}</Typography>
                <Link
                  className="remove-lbl"
                  onClick={() => {
                    if (coupon) {
                      dispatch(clearCoupon());
                    }
                    dispatch(removeDirectCourse(directCourses.indexOf(course)));
                  }}
                >
                  <DeleteOutlinedIcon />
                  Remove
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Display Self-Paced Courses */}
      {selfPacedCourses?.length > 0 && (
        <div className="courses-section">
          {selfPacedCourses.slice() 
          .sort((a, b) => a.name.localeCompare(b.name)).map((course, index) => (
            <div className="product-grid" key={`course-${index}`}>
              <div className="left-product-grid">
                <img src={course.imgUrl} alt="img" className="prod-img" />
                <Typography className="prod-title">
                  {course.name}
                </Typography>
                {course.alreadyPurchased && <div>
                  <span className="existing_course">Already Purchased</span>
                </div>}
              </div>
              <div className="right-product-grid">
                <Typography className="price-lbl">${course.price}</Typography>
                {course.discount > 0 && (
                  <Typography className="discount-text">
                    Discount: ${course.discount}
                  </Typography>
                )}
                <Link
                  className="remove-lbl"
                  onClick={() => {
                    dispatch(removeSelectedCourse(courses.indexOf(course)));
                    if (coupon) {
                      dispatch(clearCoupon());
                    }
                  }}
                >
                  <DeleteOutlinedIcon />
                  Remove
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasInstructorLed && (
        <div className="contact-info">
          <Typography className="message-text">
            Please note this cart only contains your Self-Paced selections.
            <br />
            Our admissions team will contact you about your Instructor-Led
            selections.
          </Typography>
        </div>
      )}
    </div>
  );
}

export default ProductList;
